import { Tooltip } from '@material-ui/core';
import WarningRounded from '@material-ui/icons/WarningRounded';
import { createElement } from 'react';
import { FormattedMessage } from 'react-intl';

const ModificationRequestGivenFeedbackIcon = () => (
  <FormattedMessage id="modification_request_state.given_feedback">
    {(state: string) => (
      <Tooltip placement="top" title={state}>
        <WarningRounded style={{ color: '#f9a825' }} />
      </Tooltip>
    )}
  </FormattedMessage>
);

export default ModificationRequestGivenFeedbackIcon;
